export const CATEGORY_OBJECT = {
    '658bcedee202d372af777b66': 'Makeup & Skin',
    '658bd4f28b13203c5bdb2e2c': 'Health & Pharmacy',
    '658bd52f8b13203c5bdb2e2e': 'Wellness & Personal Care',
    '658bd5498b13203c5bdb2e30': 'Fragrance',
    '658bd55d8b13203c5bdb2e32': 'Men',
    '658bd56e8b13203c5bdb2e34': 'Vitamins & Nutrition',
};
